import { Pipe, PipeTransform } from "@angular/core";
import { isDefined } from "@recursyve/nice-ts-utils";
import { sanitizeDirectusObject } from "../../../../../../../common/utils/sanitize-directus-object";
import { ItemsPackages } from "../../../../../../api/packbo/models/items-packages";
import { ItemsSuppliers } from "../../../../../../api/packbo/models/items-suppliers";

@Pipe({
    name: "sanitizeSupplierPackage"
})
export class SanitizeSupplierPackagePipe implements PipeTransform {
    public transform(suppliers: ItemsSuppliers): ItemsPackages | null {
        const sanitize = sanitizeDirectusObject(suppliers.package_ref);

        if (isDefined(sanitize)) {
            return sanitize;
        }

        return null;
    }
}
